<template>
  <div class="row ">
    <div class="col-md-12 login-holder">
      <div class="login-box ">
        <img src="../assets/logo.png" alt="Logo" class="img-fluid logo" />
        <form @submit.prevent="login">
          <div class="form-group">
            <input type="email" class="form-control" placeholder="Email" required ref="email" />
            <div class="login-icon icon-mail">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16"><g class="a" transform="translate(0 -61)"><g transform="translate(1.095 61)"><g transform="translate(0 0)"><path d="M43.743,61H26.508a1.756,1.756,0,0,0-.787.192l9.364,9.762,2.1-2.1h0l7.347-7.658A1.756,1.756,0,0,0,43.743,61Z" transform="translate(-25.721 -61)"/></g></g><g transform="translate(13.601 62.095)"><g transform="translate(0 0)"><path d="M345.42,86.728l-7.207,6.9,7.207,6.9a1.752,1.752,0,0,0,.192-.786V87.514A1.752,1.752,0,0,0,345.42,86.728Z" transform="translate(-338.213 -86.728)"/></g></g><g transform="translate(0 62.095)"><g transform="translate(0 0)"><path d="M.192,86.721A1.752,1.752,0,0,0,0,87.507V99.744a1.752,1.752,0,0,0,.192.786l7.207-6.9Z" transform="translate(0 -86.721)"/></g></g><g transform="translate(1.095 69.601)"><g transform="translate(0 0)"><path d="M37.611,277.211l-2.1,2.1a.595.595,0,0,1-.866,0l-2.017-2.1-6.914,7.207a1.756,1.756,0,0,0,.788.192H43.737a1.756,1.756,0,0,0,.787-.192Z" transform="translate(-25.714 -277.211)"/></g></g></g></svg>
            </div>
          </div>

          <div class="form-group">
            <input :type="showPass ? 'text' : 'password'" class="form-control"  placeholder="Password" ref="password" required minlength="6" />
            <div class="login-icon icon-password">
              <!-- show eye icon -->
              <svg @click="showPass = true" v-if="!showPass" xmlns="http://www.w3.org/2000/svg" width="23" height="16" viewBox="0 0 23 16"><g class="a" transform="translate(0 -74.667)"><g transform="translate(0 74.667)"><path d="M173.889,170.667a3.222,3.222,0,1,0,3.222,3.222A3.224,3.224,0,0,0,173.889,170.667Z" transform="translate(-162.389 -165.889)"/><path d="M11.5,74.667a12.372,12.372,0,0,0-11.5,8,12.372,12.372,0,0,0,11.5,8,12.367,12.367,0,0,0,11.5-8A12.367,12.367,0,0,0,11.5,74.667ZM11.5,88a5.334,5.334,0,1,1,5.227-5.333A5.283,5.283,0,0,1,11.5,88Z" transform="translate(0 -74.667)"/></g></g></svg>
              <!-- hide eye icon -->
              <svg @click="showPass = false" v-else version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 512.008 512.008" style="enable-background:new 0 0 512.008 512.008;" xml:space="preserve"   height="24">
                <g>
                  <g>
                    <path d="M256.011,106.673c-131.435,0-248.555,136.619-253.483,142.443c-3.371,3.968-3.371,9.792,0,13.781
                      c2.944,3.477,45.995,53.461,108.075,93.269l66.859-66.859c-4.352-10.24-6.784-21.483-6.784-33.301
                      c0-47.061,38.272-85.333,85.333-85.333c11.819,0,23.061,2.432,33.301,6.784l54.976-54.976
                      C317.493,112.902,288.075,106.673,256.011,106.673z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M510.112,249.926c-2.731-3.947-48.021-67.691-124.16-108.779l58.944-58.944c4.16-4.16,4.16-10.923,0-15.083
                      c-4.16-4.16-10.923-4.16-15.083,0L67.147,429.788c-4.16,4.16-4.16,10.923,0,15.083c2.069,2.091,4.8,3.136,7.531,3.136
                      c2.731,0,5.461-1.045,7.552-3.115l66.88-66.88c32.96,16.085,69.312,27.328,106.901,27.328
                      c131.435,0,248.555-136.619,253.483-142.443C512.587,259.206,512.864,253.894,510.112,249.926z M256.011,341.34
                      c-19.691,0-37.589-6.976-52.053-18.197l119.189-119.189c11.221,14.464,18.197,32.363,18.197,52.053
                      C341.344,303.068,303.072,341.34,256.011,341.34z"/>
                  </g>
                </g>
                </svg>
            </div>
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-login btn-block">Sign In</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      showPass: false
    }
  },
  methods: {
    login(){
      let email = this.$refs.email.value
      let password = this.$refs.password.value
      if(email.length > 0 && password.length > 0){
        this.$axios.post('/login', {email, password})
          .then(res => {
            let resData = res.data.data
            this.$cookies.set('crm-token', resData.token)
            this.$cookies.set('crm-user-name', resData.name)
            this.$cookies.set('crm-user-email', resData.email)
            this.$router.replace('/');
          })
          .catch(err => {
            swal({
              title: "Login Failed",
              text: err.response.data.message,
              icon: "error"
            })
          })
      }else{
        swal({
          title: "Please enter Email and Password",
          icon: "info"
        })
      }
    }
  }
}
</script>
<style scoped>
  svg{
    opacity: 0.2;
  }
</style>